import { createSlice } from "@reduxjs/toolkit";
import {
   searchAgreementsAction,
   saveMeetingAction,
   listMeetingsAction,
   updateMeetingAction,
   viewMeetingAction,
   getMeetingStatusOptionsAction,
   deleteMeetingAction,
} from "../../actions/CaseMeeting/caseMeetingAction";

const initialState = {
  loading: false,
  saving: false,
  deleting: false,
  listLoading: false,
  viewLoading: false,
  error: null,
  matchedNumbers: [],
  mismatchedNumbers: [],
  arbitratorMapped: [],
  arbitratorUnmapped: [],
  arbitratorMismatched: [],
  matchedData: [],
  saveSuccess: false,
  updateSuccess: false,
  meetingList: [],
  currentMeeting: null, 
  meetingStatusOptions: [],
};

const caseMeetingSlice = createSlice({
  name: "caseMeeting",
  initialState,
  reducers: {
    resetMeetingState: (state) => {
      state.loading = false;
      state.saving = false;
      state.deleting = false;
      state.error = null;
      state.matchedNumbers = [];
      state.mismatchedNumbers = [];
      state.arbitratorMapped = [];
      state.arbitratorUnmapped = [];
      state.arbitratorMismatched = [];
      state.matchedData = [];
      state.saveSuccess = false;
      state.updateSuccess = false;
      state.currentMeeting = null;
    },
    clearSaveSuccess: (state) => {
      state.saveSuccess = false;
      state.updateSuccess = false;
    },
    
    setMatchedData: (state, action) => {
      state.matchedData = action.payload || [];
    },
    
    setMatchedNumbers: (state, action) => {
      state.matchedNumbers = action.payload || [];
    },

    removeLocalMeeting: (state, action) => {
      state.meetingList = state.meetingList.filter(
        (m) => String(m.meetingId) !== String(action.payload),
      );
    },

    clearMeetingList: (state) => {
      state.meetingList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Search Agreements Action
      .addCase(searchAgreementsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchAgreementsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.matchedNumbers = action.payload?.matchedAgreementNumbers || action.payload?.matchedNumbers || [];
        state.mismatchedNumbers = action.payload?.mismatchedAgreementNumbers || action.payload?.mismatchedNumbers || [];
        state.arbitratorMapped = action.payload?.arbitratorMapped || [];
        state.arbitratorUnmapped = action.payload?.arbitratorUnmapped || [];
        state.arbitratorMismatched = action.payload?.arbitratorMismatched || [];
        state.matchedData = action.payload?.data || action.payload?.matchedData || [];
      })
      .addCase(searchAgreementsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to search agreements";
        state.matchedNumbers = [];
        state.mismatchedNumbers = [];
        state.arbitratorMapped = [];
        state.arbitratorUnmapped = [];
        state.arbitratorMismatched = [];
        state.matchedData = [];
      })
      // Save Meeting Action
      .addCase(saveMeetingAction.pending, (state) => {
        state.saving = true;
        state.error = null;
        state.saveSuccess = false;
      })
      .addCase(saveMeetingAction.fulfilled, (state) => {
        state.saving = false;
        state.saveSuccess = true;
      })
      .addCase(saveMeetingAction.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || "Failed to save meeting";
        state.saveSuccess = false;
      })
      // List Meetings Action
      .addCase(listMeetingsAction.pending, (state) => {
        state.listLoading = true;
        state.error = null;
      })
      .addCase(listMeetingsAction.fulfilled, (state, action) => {
        state.listLoading = false;
        state.meetingList = action.payload?.data || action.payload || [];
      })
      .addCase(listMeetingsAction.rejected, (state, action) => {
        state.listLoading = false;
        state.error = action.payload || "Failed to fetch meetings";
      })
      // Update Meeting Action
      .addCase(updateMeetingAction.pending, (state) => {
        state.saving = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateMeetingAction.fulfilled, (state) => {
        state.saving = false;
        state.updateSuccess = true;
      })
      .addCase(updateMeetingAction.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || "Failed to update meeting";
        state.updateSuccess = false;
      })
      // View Meeting Action (for edit form pre-population)
      .addCase(viewMeetingAction.pending, (state) => {
        state.viewLoading = true;
        state.error = null;
        state.currentMeeting = null;
      })
      .addCase(viewMeetingAction.fulfilled, (state, action) => {
        state.viewLoading = false;
        state.currentMeeting = action.payload?.data || action.payload || null;
      })
      .addCase(viewMeetingAction.rejected, (state, action) => {
        state.viewLoading = false;
        state.error = action.payload || "Failed to load meeting";
      })
      // Get Meeting Status Options Action
      .addCase(getMeetingStatusOptionsAction.pending, (state) => {
        state.error = null;
      })
      .addCase(getMeetingStatusOptionsAction.fulfilled, (state, action) => {
        state.meetingStatusOptions = action.payload?.data || [];
      })
      .addCase(getMeetingStatusOptionsAction.rejected, (state, action) => {
        state.error = action.payload || "Failed to fetch meeting status options";
      })
      // Delete Meeting Action
      .addCase(deleteMeetingAction.pending, (state) => {
        state.deleting = true;
        state.error = null;
      })
      .addCase(deleteMeetingAction.fulfilled, (state) => {
        state.deleting = false;
      })
      .addCase(deleteMeetingAction.rejected, (state, action) => {
        state.deleting = false;
        state.error = action.payload || "Failed to delete meeting";
      });
  },
});

export const { resetMeetingState, clearSaveSuccess, setMatchedData, setMatchedNumbers, removeLocalMeeting, clearMeetingList } = caseMeetingSlice.actions;
export default caseMeetingSlice.reducer;
